import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { InputBase, MenuItem, Select } from "@mui/material";
import { styled } from "@mui/material/styles";
import styles from "../../assets/css/modules/SelectInputGroup.module.css";

const InputStyle = styled(InputBase)(({ theme, customBg }) => ({
  "& .MuiInputBase-input": {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    border: "1.5px solid #e2e8f0",
    borderRadius: "10px",
    background: customBg || "#f8fafc",
    fontSize: 15,
    padding: "12px 28px 12px 16px",
    color: "#0f172a",
    transition: "all 0.2s ease-in-out",
    "&:focus": {
      background: "#ffffff",
      borderColor: "#13cae9",
      boxShadow: "0 0 0 4px rgba(19, 202, 233, 0.1)",
    },
  },
}));

export default function SelectInputGroup(props) {
  const backgroundColor =
    props.selectProps?.style?.backgroundColor || "#FFFFFF";
  const { itemName, itemValue } = props;
  const { control } = useFormContext();
  return (
    <div className={styles.container}>
      <div className={styles.inputGroup}>
        <label className={styles.label}>{props.label}</label>
        <Controller
          name={props.name}
          control={control}
          rules={
            props.applyRules ? { required: `${props.errorMassage}` } : null
          }
          render={({ field }) => (
            <Select
              style={props.selectProps?.style}
              disabled={props.disabled}
              {...field}
              displayEmpty
              sx={{ width: "300px", minWidth: "300px" }}
              input={<InputStyle customBg={props.background} />}
            >
              <MenuItem sx={{ color: "#828EAE" }} value={""} disabled>
                {props.placeholder}
              </MenuItem>
              {props.items.map((item, index) => (
                <MenuItem
                  key={item[itemName]}
                  value={itemValue ? item[itemValue] : index + 1}
                >
                  {item[itemName]}
                </MenuItem>
              ))}
            </Select>
          )}
        />
      </div>
      {props.error ? (
        <p className={styles.error}>{props.error.message}</p>
      ) : null}
    </div>
  );
}
